import { Observable, OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

export function filterNullUndefined<T>(): OperatorFunction<
  T | undefined | null,
  T
> {
  return (source$: Observable<null | undefined | T>) =>
    source$.pipe(
      filter((v): v is NonNullable<T> => v !== null && v !== undefined),
    );
}
